const Helpers = {
  getOwnerId() {
    let user = JSON.parse(localStorage.getItem('user'));
    if(!user) {
      return null;
    }

    return user.person.client.person_id
  },
  isOwner() {
    let user = JSON.parse(localStorage.getItem('user'));

    return user.person.client.person_id == user.person.id;
  },
  checkOwner(personId) {
    let user = JSON.parse(localStorage.getItem('user'));

    return user.person.client.person_id == personId;
  },
  checkSelf(personId) {
    let user = JSON.parse(localStorage.getItem('user'));

    return user.person.id == personId;
  },
  checkPermission(module, permission, overwriteOwner = false) {
    if(!this.isOwner() || overwriteOwner) {
      let user = JSON.parse(localStorage.getItem('user'));

      if (typeof user.person.permissions != 'undefined') {
        let pFounded = user.person.permissions.find(p => {
          return p.module == module;
        });

        if (pFounded != null && pFounded[permission]) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  },
  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },
  getModules() {
    return [
      { module: 'agendas', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'patients', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'professionals', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'secretaries', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'permissions', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'forms', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'dashboard', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'client-data', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'incomes', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'expenses', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'cash-flow', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
    ]
  },
  getModuleName(module) {
    let moduleName = '';
    switch (module) {
      case 'agendas':
        moduleName = 'Agendas';
        break;
      case 'patients':
        moduleName = 'Pacientes';
        break;
      case 'professionals':
        moduleName = 'Profissionais';
        break;
      case 'secretaries':
        moduleName = 'Secretárias';
        break;
      case 'permissions':
        moduleName = 'Permissões';
        break;
      case 'forms':
        moduleName = 'Prontuários';
        break;
      case 'dashboard':
        moduleName = 'Dashboard';
        break;
      case 'client-data':
        moduleName = 'Dados do Consultório';
        break;
      case 'incomes':
        moduleName = 'Contas a Receber';
        break;
      case 'expenses':
        moduleName = 'Contas a Pagar';
        break;
      case 'cash-flow':
        moduleName = 'Fluxo de Caixa';
        break;
    }
    return moduleName;
  },
  getStatusName(status) {
    switch (status) {
      case 'SCHEDULED':
        status = 'Agendado';
        break;
      case 'CONFIRMED':
        status = 'Confirmado';
        break;
      case 'CANCELED':
        status = 'Cancelado';
        break;
      case 'MISSED':
        status = 'Faltou';
        break;
      case 'SHOWEDUP':
        status = 'Compareceu';
        break;
      case 'ATTENDED':
        status = 'Atendido';
        break;
      case 'FINISHED':
        status = 'Finalizado';
        break;
      default:
        status = (status.indexOf('RESCHEDULED') > -1)?'Reagendado':'Não identificado';
        break;
    }
    return status;
  },
  clone(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
  }
};

export default Helpers
